export default "__VITE_ASSET__1phQlLo9__"